import { IncidentsCreateRedirect } from '../../pages/incidents/IncidentsCreateRedirect';

const IncidentsList = async () =>
    import('../../pages/incidents/list/List').then((module) => ({
        Component: module.IncidentsList,
    }));

const getIncidentsRoutes = () => {
    return [
        {
            path: '/logistic-management/incidents/create',
            element: <IncidentsCreateRedirect />,
        },
        {
            path: '/logistic-management/incidents/',
            lazy: IncidentsList,
        },
        {
            path: '/logistic-management/incidents/view/:viewId',
            lazy: IncidentsList,
        },
    ];
};

export { getIncidentsRoutes };
